/**
 * Trip log — distance run over the ground, summed along a track. A simple,
 * resettable odometer derived from the track points the ownship already lays
 * down; no extra state to keep in sync.
 */
import { rhumbDistanceNm } from '@/nav';

export interface TripLeg {
  position: [number, number];
}

/** Total rhumb distance along a sequence of points, nautical miles. */
export function tripDistanceNm(points: TripLeg[]): number {
  let sum = 0;
  for (let i = 1; i < points.length; i++) {
    sum += rhumbDistanceNm(points[i - 1].position, points[i].position);
  }
  return sum;
}

/** Average speed over the ground for a trip, knots (0 if no time elapsed). */
export function tripAverageKn(distanceNm: number, hours: number): number {
  return hours > 0 ? distanceNm / hours : 0;
}
